<template lang="pug">
    .l-flex-row--between.formula-settings
        .general-settings.l-flex-row
            //- Recency
            .formula-setting.l-flex-row
                svg-icon.formula-setting-icon(
                    name="calendar"
                    size="small"
                    title="Recency"
                )
                .formula-setting-label Recency
                .formula-setting-value
                    select(
                        :value="formula.defaultRecency.value"
                        @click="onRecencyChange($event)"
                    )
                        option(
                            v-for="(item,index) in formula.defaultRecency.availableValues"
                            :key="index" :value="item"
                        ) {{ displayRecencyValue(item) }}

            //- Quantile
            .formula-setting.l-flex-row(
                :class="quantileDisabled" v-if="formula.defaultQuantile.display")
                svg-icon.formula-setting-icon(name="quantile" size="small" title="Quantile")
                .formula-setting-label Quantile
                .formula-setting-value
                    select(:value="formula.defaultQuantile.value" @click="onQuantileChange($event)")
                        option(v-for="(item,index) in formula.defaultQuantile.availableValues", :key="index"  :value="item") {{ item }}

            //- Surf Intensity
            .formula-setting.l-flex-row(
                :class="surfIntensityDisabled" v-if="formula.defaultSurfIntensity.display")
                svg-icon.formula-setting-icon(name="target" size="small" title="Surf Intensity")
                .formula-setting-label Surf Intensity
                .formula-setting-value
                    select(:value="formula.defaultSurfIntensity.value" @click="onSurfIntensityChange($event)")
                        option(v-for="(item,index) in formula.defaultSurfIntensity.availableValues", :key="index"  :value="item") {{ item }}

        .volume-setting.l-flex-row
            .formula-setting.l-flex-row(:class="{ 'no-pointer': !xDeviceSetting }")
                .formula-setting-label Volumes
                .formula-setting-value
                    <template v-if="xDeviceSetting">
                        <el-radio-group v-model="volumeSelected" @change="handleVolumeChange">
                            <el-radio-button v-for="(item,index) in volumesValues" :key="index" class="btn-radio" :label="item" :value="item" />
                        </el-radio-group>
                    </template>
                    span.txt(v-else) ID based
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { RadioButton, RadioGroup } from 'element-ui'

export default {
    name: 'FormulaSettings',

    props: {
        formula: {
            type: Object,
            required: true
        }
    },

    components: {
        'el-radio-button': RadioButton,
        'el-radio-group': RadioGroup
    },

    data() {
        return {
            volumeSelected: 'ID based'
        }
    },

    computed: {
        ...mapState('data/settings', {
            xDeviceSetting: state => state.general.xdevice,
            quantile: state => state.general.quantile,
            surfIntensity: state => state.general.surfintensity
        }),

        ...mapState('builder', {
            volumeType: state => state.formulaVolumeType
        }),

        volumesValues() {
            return this.xDeviceSetting ? ['ID based', 'Cross device'] : ['ID based']
        },

        quantileDisabled() {
            return this.formula.defaultQuantile.disabled ? 'ui-disabled' : ''
        },

        surfIntensityDisabled() {
            return this.formula.defaultSurfIntensity.disabled ? 'ui-disabled' : ''
        }
    },

    methods: {
        ...mapMutations('builder', ['setFormulaVolumeType', 'setFormula']),

        async onRecencyChange(event) {
            const recency = parseInt(event.target.value)
            this.formula.setRecency(recency)
            await this.$nextTick()
            this.setFormula(this.formula)
        },

        async onQuantileChange(event) {
            const quantile = parseInt(event.target.value)
            this.formula.setQuantile(quantile)
            await this.$nextTick()
            this.setFormula(this.formula)
        },

        async onSurfIntensityChange(event) {
            const surfIntensity = parseInt(event.target.value)
            this.formula.setSurfIntensity(surfIntensity)
            await this.$nextTick()
            this.setFormula(this.formula)
        },

        displayRecencyValue(value) {
            return value === 1 ? value + ' day' : value + ' days'
        },

        handleVolumeChange(value) {
            this.setFormulaVolumeType(value)
        }
    }
}
</script>

<style lang="scss">

.formula-setting {
    &.no-pointer {
        cursor: default;
    }
}
.el-radio-group {
    margin-left: 10px;
    .el-radio-button {
        &.btn-radio {
            .el-radio-button__inner {
                height: 20px;
                line-height: 4px;
                font-size: 1rem;
                outline: unset;
            }
        }
    }
}
</style>
